module.exports = __webpack_public_path__ + "media/images/icons/form_professional_step_3-9583973024a2f6340ef797ec00f0b35f.svg";